import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { TARIFF_TV } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import Routes from "Configs/routes";
import { getDeclination } from "Utils/text";
import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import { svgAction } from "Constants/SVG";
import ConnectButton from "Containers/Buttons/ConnectButton";
import { Tooltip, TooltipBody } from "ComponentsUI/Tooltip";
import { ModalLayout } from "ComponentsUI/Modallayout";
import {
	TariffsRow,
	ProviderLogo,
	MeasureA,
	MeasurePrice,
	DodysList,
	MobileData,
} from "ComponentsUI/TarifficationB";
import moment from "moment";
import "moment/locale/ru";
moment.locale("ru");

@inject("ApplicationModel")
@observer
export default class RecentlyConnectedRowContainer extends React.Component {
	/*    onReviewClick() {
        let modalModel = this.props.ApplicationModel.modalModel;
        let text = this.props.ApplicationModel.text;
        import("Containers/RatesReviews/index").then(RatesReviewsContainer => {
            modalModel.toggleModal(
                <ModalLayout closeModal={() => this.closeModal()}>
                    <RatesReviewsContainer.default
                        text={text}
                        provider={this.props.data.provider}
                    />
                </ModalLayout>
            );
        });
    }*/

	closeModal() {
		let modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}
	// Клик на каналы
	onClickAddHandlerTv() {
		if (!!this.props.data.tv.use_text) {
			return;
		}

		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let promise1 = import("Containers/ChannelsContainer");
		let apolloTariffQueryPromise = this.props.ApplicationModel.apolloTransportLayer.query({
			query: TARIFF_TV,
			variables: {
				id: this.props.data.id,
			},
		});
		Promise.all([promise1, apolloTariffQueryPromise]).then((modules) => {
			let ChannelsContainer = modules[0].default;
			let tariff = modules[1].data.tariffsOne;
			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<ChannelsContainer tariff={tariff} />
				</ModalLayout>
			);
		});
	}

	// Клик по проверке адреса
	clickConnectHandler() {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;

		let tariff = this.props.data;

		if (this.props.isRecently) {
			sendMetriks("CLICK_CHECK_ADDRESS");
		}

		if (this.props.isReviewsProviders) {
			sendMetriks("CLICK_TARIFF_FROM_OTZYVY_NEVIP");
		}

		// Задать метку фром в зависимости от места отрисовки таблицы
		if (this.props.isCard) {
			Cookies.set("connectTariffFrom", "recently_connected_from_nevip_o_providere");
		} else if (this.props.isRates) {
			Cookies.set("connectTariffFrom", "recently_connected_from_nevip_rates");
		} else if (this.props.isOrderToHome) {
			Cookies.set("connectTariffFrom", "recently_connected_orders_tohome");
		} else if (this.props.isReviewsProviders) {
			Cookies.set("connectTariffFrom", "recently_connected_from_nevip_otzyvy");
		} else if (this.props.isRecently) {
			Cookies.set("connectTariffFrom", "recently_connected_from_nevip");
		} else {
			Cookies.set("connectTariffFrom", "");
		}

		tariffsModel.setTariff(tariff);
	}

	// Клик по провайдеру
	onClickHandler() {
		let providerModel = this.props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_card");
	}

	getChannelDeclination(count) {
		const { text } = this.props.ApplicationModel;

		return getDeclination(
			count,
			text.SERVICES_CHANNEL_SUFFIX.ONE,
			text.SERVICES_CHANNEL_SUFFIX.TWO,
			text.SERVICES_CHANNEL_SUFFIX.MANY
		);
	}

	onClickHref = () => {
		window.open(this.props.data.provider.contacts.link, "_blank");

		return false;
	};

	render() {
		let texts = this.props.ApplicationModel.text;
		let data = this.props.data;
		let windowSizeModel = this.props.ApplicationModel.windowSizeModel;
		let connectTariffButton =
			this.props.ApplicationModel?.siteConfig?.settings?.recently_connect_tariff_button;
		let connectAction = this.props.ApplicationModel?.siteConfig?.settings?.connect_action;

		// Количество отзывов и рейтинг только по домашнему интернету
		const provider = data.provider;
		const orderType = provider?.rating?.order_types?.find((x) => x.order_type_id === 1);

		let position = orderType?.position;
		let positionInRating = position ? position : null;
		let in_main_rating = orderType?.in_main_rating;

		let reviews_count = orderType?.review_all;

		let districtsArr = data?.districts?.map((item) => item.name) || [];

		let newDistricts = districtsArr.join(", ");

		const providerReviewUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: data.region.url,
			providerName: data.provider.url_name,
		});

		// Логотип провайдера
		let providerLogo = !this.props.hideProviderLogo ? (
			<ProviderLogo
				viewPopup={true}
				providerReviewUrl={providerReviewUrl}
				texts={texts}
				path={webpTransformer(replaceStaticHost(data.provider.logo_2))}
				reviewsCounter={reviews_count || 0}
				rating={provider?.rating && in_main_rating}
				name={`${data.provider.name}`}
				position={positionInRating}
				windowSizes={windowSizeModel.windowSizes}
			/>
		) : null;

		// Скорость интернета
		let speedComponent =
			data.internet && data.internet.speed_in ? (
				<MeasureA
					value={data.internet && data.internet.speed_in}
					typeA={true}
					measure={texts.MBPS}
				/>
			) : null;

		// Каналы
		let channels = null;
		if (data.tv && (data.tv.channels || data.tv.channels_hd)) {
			channels = data.tv.channels;
			if (data.tv.channels_hd) {
				channels = !!channels
					? channels + " + " + data.tv.channels_hd + "HD"
					: data.tv.channels_hd + "HD";
			}
		}

		const channelsCount = data.tv?.channels + data.tv?.channels_hd;
		let channelsComponent = channels ? (
			<MeasureA
				value={channels}
				typeA={true}
				onClickHandler={() => this.onClickAddHandlerTv()}
				usePointer={!data.tv.use_text}
				measure={this.getChannelDeclination(channelsCount || 0)}
			/>
		) : null;

		// Мобильная связь
		let mobileDataComponent = null;

		if (!!data.mobile_new) {
			let mobileData = data.mobile_new;
			let internetValue = parseInt(mobileData.internet);
			let callsValue = parseInt(mobileData.calls);
			let smsValue = parseInt(mobileData.sms);

			mobileDataComponent = (
				<MobileData
					data={[
						{
							value: internetValue,
							measure: texts.gb,
							type: mobileData.internet_type,
						},
						{
							value: callsValue,
							measure: texts.min,
							type: mobileData.calls_type,
						},
						{
							value: smsValue,
							measure: texts.sms,
							type: mobileData.sms_type,
						},
					]}
				/>
			);
		}

		let connectText = !!data.connection?.price
			? `${data.connection.price} ${texts.SERVICES_RUB}`
			: texts.servicesFree;
		let prepaidText = data.price.system_calculation_connect
			? `${texts.AVANS} ${data.price.system_calculation_connect} ${texts.SERVICES_RUB}`
			: "";
		// Опции тарифа
		let dodyComponent =
			!!data.dody && !!data.dody.length ? (
				<DodysList
					items={[...data.dody]}
					windowSizeModel={windowSizeModel}
					connectText={connectText}
					prepaidText={prepaidText}
					texts={texts}
				/>
			) : null;

		let actionImageComponent =
			data.dody[4].state === 1 ? (
				<svg
					width={"49"}
					height={"11"}
					viewBox={"0 0 49 11"}
					fill={"none"}
					xmlns={"http://www.w3.org/2000/svg"}
				>
					<path d={svgAction} fill={"#5813FE"}></path>
				</svg>
			) : null;

		// Цена тарифа
		let valuePrice = {
			price: `${data.displayPrice}`,
		};
		if (
			data?.after?.data?.price?.license_fee_month &&
			data?.after?.data?.price?.license_fee_month !== data.price.license_fee
		) {
			valuePrice.sale = `${data.price.license_fee}`;
		}

		let priceMeasure = null;
		if (data.price.license_fee_interval.code === "month") {
			priceMeasure = texts.SUBSCRIPTION_FEE_TITLE;
		}
		if (data.price.license_fee_interval.code === "day") {
			priceMeasure = texts.PRICE_IN_DAY;
		}

		let priceComponent;

		if (valuePrice.sale) {
			let textTimeGracePeriod;

			if (!data?.after.rule.month_cnt || data?.after.rule.month_cnt === 0) {
				textTimeGracePeriod = `до ${moment(data?.after.rule.date_end).format("D MMMM YYYY")}`;
			} else {
				textTimeGracePeriod = `${data?.after.rule.month_cnt} ${texts.SERVICES_MONTH}`;
			}

			let salePeriodText = (
				<div>
					<div>{`${texts.ORDER_FORM_GRACE_PERIOD_TITLE}:`}</div>
					<div>{`${textTimeGracePeriod}`}</div>
				</div>
			);

			// let saleCostText = (
			//     <div>
			//         <div>{`${texts.ORDER_FORM_FEE_PREF}:`}</div>
			//         <div>{`${valuePrice.sale} ${priceMeasure}`}</div>
			//     </div>
			// );
			priceComponent = (
				<Tooltip
					body={<TooltipBody priceSale={true}>{salePeriodText}</TooltipBody>}
					priceSale={true}
					v3={true}
				>
					<MeasurePrice
						value={valuePrice.price}
						valueSale={valuePrice.sale}
						measure={priceMeasure}
						withAsterisk={true}
					/>
				</Tooltip>
			);
		} else {
			priceComponent = (
				<MeasurePrice value={valuePrice.price} valueSale={valuePrice.sale} measure={priceMeasure} />
			);
		}

		let providerUrl = generateUrl(Routes.ProviderRates.route, {
			regionUrl: data.region.url,
			providerName: data.provider.url_name,
		});
		let providerNameComponent = !this.props.hideProviderLogo ? (
			<Link to={providerUrl}>{data.provider.name}</Link>
		) : null;
		let providerDistrictsComponent1 =
			!!this.props.hideProviderLogo && !!data.districts ? `(${newDistricts})` : null;
		let providerDistrictsComponent2 = !!data.districts ? `(${newDistricts})` : null;
		let providerDistrictsComponent =
			providerDistrictsComponent1 || providerDistrictsComponent2 || null;

		let buttonConnect = (
			<ConnectButton
				data={data}
				providerInfo={data.provider}
				pageName={this.props.pageName}
				recentlyConnect={true}
				compareIsHideInConnectTariffs={this.props.compareIsHideInConnectTariffs}
			/>
		);

		let ButtonDataTest;
		if (this.props.recently) {
			ButtonDataTest = "recently_connected_tariffs_connect_tariff_button";
		} else if (this.props.action) {
			ButtonDataTest = "action_tariffs_connect_tariff_button";
		}

		return (
			<TariffsRow
				data={data}
				name={this.props.data.name}
				compareIsHide={true}
				hideProviderLogo={false}
				providerNameComponent={providerNameComponent}
				providerDistrictsComponent={providerDistrictsComponent}
				logoComponent={providerLogo}
				speedComponent={speedComponent}
				channelsComponent={channelsComponent}
				mobileDataComponent={mobileDataComponent}
				priceComponent={priceComponent}
				actionImageComponent={actionImageComponent}
				dodyComponent={dodyComponent}
				buttonConnectComponent={buttonConnect}
				texts={texts}
				connectButtonDatatest={ButtonDataTest}
				onClickConnect={() => this.clickConnectHandler()}
				onClickHandler={() => this.onClickHandler()}
				windowSizes={windowSizeModel.windowSizes}
			/>
		);
	}
}
